import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserDetails } from '../apimodels/user/user-details';
import { Environment, ENVIRONMENT } from '@classifieds-sell/environment';
import { UserUpdateDetailsRequest } from '@classifieds-sell/datalayer';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    constructor(
        private httpClient: HttpClient,
        @Inject(ENVIRONMENT) private env: Environment
    ) {}

    public getUserDetails(): Observable<UserDetails> {
        return this.httpClient.get<UserDetails>(`${this.env.apiUrl}/User`, {
            withCredentials: true
        });
    }

    public updateUserDetails(
        userUpdateDetailsRequest: UserUpdateDetailsRequest
    ): Observable<string> {
        return this.httpClient.post<string>(
            `${this.env.apiUrl}/User/update`,
            userUpdateDetailsRequest,
            {
                withCredentials: true
            }
        );
    }
}
